import { PROOF_ITEMS } from "../data/mock";

export const ProofSection = () => {
  return (
    <section id="proof" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="max-w-2xl mb-16">
          <span className="text-sm font-bold text-[#7EA13E] uppercase tracking-widest mb-3 block">
            Proven Results
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-[#2C2A2B] leading-tight mb-4">
            Outcomes That Speak{" "}
            <span className="text-[#308795]">Louder Than Promises</span>
          </h2>
          <p className="text-[#6B6567] text-lg leading-relaxed">
            Real metrics from real clients. Our work delivers measurable
            improvements, not just implementations.
          </p>
        </div>

        {/* Proof Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PROOF_ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={i}
                className="group relative bg-[#FAFAF7] rounded-2xl border border-[#E0D1BB]/30 p-8 transition-all duration-400 hover:shadow-lg hover:-translate-y-1"
              >
                {/* Metric Highlight */}
                <div className="flex items-end gap-2 mb-6">
                  <span className="text-5xl font-extrabold text-[#308795] leading-none">
                    {item.metric}
                  </span>
                  <span className="text-sm font-semibold text-[#8A8385] pb-1">
                    {item.metricLabel}
                  </span>
                </div>

                {/* Icon + Industry */}
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-lg bg-[#E5BD77]/15 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#A56A3E]" />
                  </div>
                  <span className="text-xs font-bold text-[#A56A3E] uppercase tracking-wider">
                    {item.industry}
                  </span>
                </div>

                <h3 className="text-xl font-bold text-[#2C2A2B] mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-[#6B6567] leading-relaxed">
                  {item.description}
                </p>

                {/* Decorative accent bar */}
                <div className="absolute bottom-0 left-8 right-8 h-1 rounded-full bg-gradient-to-r from-[#308795]/20 to-[#E5BD77]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
